/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_ClearInputs */

const en_field_clear = /** @type {(inputs: Field_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const de_field_clear = /** @type {(inputs: Field_ClearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leeren`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Field_ClearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const field_clear = /** @type {((inputs?: Field_ClearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_ClearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_field_clear(inputs)
	return en_field_clear(inputs)
});